// Module
var code = `<!-- HERO — v2 RATIFIED (copy of record 2026-08-13) · evolve-band added 2026-08-22 · three-unit structure 2026-08-22 · feature pair 2026-08-22 -->

<!-- Old: The Behavior-First<br>Frontend Framework -->
<section aria-labelledby="hero-headline">
    <div class="hero-unit hero-unit--identity">
        <h1 class="hero-headline landing-headline"><span class="landing-eyebrow">SIX YEARS IN FORTUNE 100 PRODUCTION · OPEN SOURCE</span>
            AI-Native<br>Application Structure
        </h1>
        <p class="hero-sub-1">Rules-based code generation.<br>Precise, verifiable, and consistent</p>
    </div>

    <div class="hero-unit hero-unit--action">
        <div class="cta-buttons">
            <button type="button"
                    title="Copy command"
                    class="landing-btn landing-btn-outline landing-btn-cli cli-snippet">
                <code>npx spyne-cli create-app</code>
                <span class="landing-btn-cli__icon" aria-hidden="true">⧉</span>
            </button>
            <a data-channel="ROUTE"
               data-event-prevent-default="true"
               data-page-id="docs"
               data-stage="examples"
               data-text="Docs"
               href="/docs/examples"
               class="landing-btn landing-btn-primary">Learn from Examples</a>
        </div>
    </div>

    <div class="hero-unit hero-unit--context">
        <ul class="landing-tile-grid landing-tile-grid--2" aria-label="What SpyneJS gives you">
            <li class="landing-tile">
                <h2 class="landing-tile__name">Evolve applications without the guesswork</h2>
                <p class="landing-tile__body">SpyneJS replaces ambiguous patterns with rules that can express the full range of web experiences: clear roles for each part of an application, and a known place for every feature.</p>
            </li>
            <li class="landing-tile">
                <h2 class="landing-tile__name">Runs anywhere, connects to your systems</h2>
                <p class="landing-tile__body">A SpyneJS application is complete and self-contained, and deploys on any hosting infrastructure. The databases, APIs, and services you already run enter as declared channels.</p>
            </li>
        </ul>
    </div>
</section>
`;
// Exports
module.exports = code;